<template>
  <div class="menu-table-view">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1>Gestión de Menús - Estilo 1</h1>
      <div class="d-flex gap-2">
        <button @click="exportToExcel" class="btn btn-success">
          <i class="bi bi-file-earmark-excel me-1"></i> Exportar a Excel
        </button>
        <button @click="addMenu" class="btn btn-primary">
          <i class="bi bi-plus-circle me-1"></i> Nuevo Menú
        </button>
      </div>
    </div>
    
    <!-- Filtros -->
    <div class="card mb-4 bg-light">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-4">
            <div class="form-group">
              <label for="filterTitulo">Título</label>
              <input 
                type="text" 
                id="filterTitulo" 
                :value="controller.filters.titulo"
                @input="controller.updateFilter('titulo', $event.target.value)"
                class="form-control" 
                placeholder="Buscar por título"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="filterEnlace">Enlace</label>
              <input 
                type="text" 
                id="filterEnlace" 
                :value="controller.filters.enlace"
                @input="controller.updateFilter('enlace', $event.target.value)"
                class="form-control" 
                placeholder="Buscar por enlace"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="filterEstado">Estado</label>
              <select id="filterEstado" :value="controller.filters.estado" @change="controller.updateFilter('estado', $event.target.value)" class="form-select">
                <option value="">Todos</option>
                <option value="true">Activos</option>
                <option value="false">Inactivos</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Tabla -->
    <div class="card shadow">
      <div class="card-body p-0">
        <div class="alert alert-info m-3" v-if="loading">Cargando menús...</div>
        <div class="alert alert-danger m-3" v-if="error">{{ error }}</div>
        
        <div v-if="!loading && !error" class="table-responsive">
          <table class="table table-hover table-striped mb-0 custom-table">
            <thead>
              <tr>
                <th @click="sortBy('Menu_id')" class="sortable">
                  ID <i :class="getSortIcon('Menu_id')"></i>
                </th>
                <th @click="sortBy('Titulo')" class="sortable">
                  Título <i :class="getSortIcon('Titulo')"></i>
                </th>
                <th @click="sortBy('Descripcion')" class="sortable">
                  Descripción <i :class="getSortIcon('Descripcion')"></i>
                </th>
                <th @click="sortBy('Enlace')" class="sortable">
                  Enlace <i :class="getSortIcon('Enlace')"></i>
                </th>
                <th @click="sortBy('Orden')" class="sortable">
                  Orden <i :class="getSortIcon('Orden')"></i>
                </th>
                <th @click="sortBy('Es_activo')" class="sortable">
                  Estado <i :class="getSortIcon('Es_activo')"></i>
                </th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="filteredMenus.length === 0">
                <td colspan="7" class="text-center py-4">
                  No se encontraron menús con los filtros aplicados
                </td>
              </tr>
              <tr v-for="menu in filteredMenus" :key="menu.Menu_id">
                <td>{{ menu.Menu_id }}</td>
                <td>{{ menu.Titulo }}</td>
                <td>{{ menu.Descripcion }}</td>
                <td>{{ menu.Enlace }}</td>
                <td>{{ menu.Orden }}</td>
                <td>
                  <span :class="menu.Es_activo ? 'badge bg-success' : 'badge bg-danger'">
                    {{ menu.Es_activo ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
                <td>
                  <div class="btn-group">
                    <button @click="editMenu(menu)" class="btn btn-sm btn-warning me-1">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button @click="confirmDelete(menu)" class="btn btn-sm btn-danger">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    
    <!-- Modal de confirmación -->
    <div class="modal fade" id="deleteModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmar eliminación</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" v-if="menuToDelete">
            ¿Está seguro que desea eliminar el menú "{{ menuToDelete.Titulo }}"?
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-danger" @click="deleteMenu">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import MenuTableView1Controller from '../controllers/MenuTableView1Ctrl.js';

export default {
  name: 'MenuTableView1',
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new MenuTableView1Controller()
    };
  },
  computed: {
    filteredMenus() {
      return this.controller.filteredMenus;
    },
    loading() {
      return this.controller.isLoading;
    },
    error() {
      return this.controller.currentError;
    },
    menus() {
      return this.controller.menusList;
    },
    menuToDelete() {
      return this.controller.selectedMenuToDelete;
    }
  },
  async mounted() {
    await this.controller.init();
  },
  methods: {
    async fetchMenus() {
      await this.controller.fetchMenus();
    },
    
    sortBy(key) {
      this.controller.sortBy(key);
    },
    getSortIcon(key) {
      return this.controller.getSortIcon(key);
    },
    
    addMenu() {
      this.$router.push('/menus/add');
    },
    
    editMenu(menu) {
      this.$router.push(`/menus/edit/${menu.Menu_id}`);
    },
    
    confirmDelete(menu) {
      this.controller.setMenuToDelete(menu);
    },
    
    async deleteMenu() {
      const result = await this.controller.deleteMenu();
      
      if (result.success) {
        this.$mgkAlert.success(result.message);
      } else {
        this.$mgkAlert.error(result.message);
      }
    },
    
    exportToExcel() {
      const result = this.controller.exportToExcel();
      
      if (result.success) {
        this.$mgkAlert.success(result.message);
      } else {
        this.$mgkAlert.error(result.message);
      }
    }
  }
};
</script>

<style scoped>
.menu-table-view {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.custom-table {
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table thead th {
  background-color: #343a40;
  color: white;
  padding: 12px;
  font-weight: 500;
  text-align: left;
  border-bottom: none;
}

.custom-table tbody td {
  padding: 12px;
  vertical-align: middle;
}

.sortable {
  cursor: pointer;
  user-select: none;
}

.sortable:hover {
  background-color: #2c3136;
}

.btn-group .btn {
  padding: 0.25rem 0.5rem;
}
</style>
